import React, { useEffect, useRef, useState } from "react";

type HeaderProps = {
  children: React.ReactNode;
  className?: string;
  showMobileBtn?: boolean;
  noSticky?: boolean;
};

const Header: React.FC<
  React.DetailedHTMLProps<
    React.AllHTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > &
    HeaderProps
> = ({ children, className, showMobileBtn = true, noSticky, ...rest }) => {
  const ref = useRef<HTMLDivElement>(null);

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        const { top } = ref.current.getBoundingClientRect();
        const isTopPage = window.scrollY > 0;
        setIsSticky(top <= 0 && isTopPage);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      data-testid="header-wrapper"
      className={`h-[88px] flex justify-center ${
        !noSticky && "sticky"
      } top-0 z-50 ${isSticky && "shadow-sticky-nav"} ${className}`}
      ref={ref}
      {...rest}
    >
      <header
        data-testid="header"
        className={
          "h-full flex items-center justify-between w-full max-w-[1280px] mx-auto lg:mx-10"
        }
      >
        {children}
      </header>
    </div>
  );
};

export default Header;
